import React from 'react';
import { Bell, Radio } from 'lucide-react';
import type { LstUpcomingAlert } from '../services/lstAlerts';

interface LstAndonBannerProps {
  alerts: LstUpcomingAlert[];
}

/** Andon visual — alertas antecipados de rotinas no turno. */
export const LstAndonBanner: React.FC<LstAndonBannerProps> = ({ alerts }) => {
  const visible = alerts.filter((a) => a.channel === 'andon' || a.channel === 'both');
  if (visible.length === 0) return null;

  const top = visible[0];
  return (
    <div
      className={`mb-2 flex shrink-0 items-center gap-2 rounded-md border px-3 py-2 ${
        top.isCritical
          ? 'border-red-300 bg-red-50 animate-pulse dark:border-red-800 dark:bg-red-900/25'
          : 'border-amber-300 bg-amber-50 dark:border-amber-800 dark:bg-amber-900/20'
      }`}
    >
      <Radio size={16} className={top.isCritical ? 'text-red-500' : 'text-amber-500'} />
      <div className="min-w-0 flex-1">
        <p className={`text-[12px] font-bold ${top.isCritical ? 'text-red-700 dark:text-red-300' : 'text-amber-800 dark:text-amber-200'}`}>
          {top.title} · {top.scheduledTime}
        </p>
        <p className="text-[10px] text-slate-500 dark:text-slate-400">
          Em {top.minutesUntil} min · alerta antecipado de {top.alertLeadMinutes} min
        </p>
      </div>
      {(top.channel === 'both') && <Bell size={14} className="shrink-0 text-slate-400" />}
      {visible.length > 1 && (
        <span className="shrink-0 rounded bg-white/80 px-1.5 py-0.5 text-[10px] font-bold text-slate-500 dark:bg-slate-900/50">
          +{visible.length - 1}
        </span>
      )}
    </div>
  );
};

export default LstAndonBanner;
